<template>
    <div>
        <el-breadcrumb separator="/">
            <el-breadcrumb-item :to="{ path: '/home' }">首页</el-breadcrumb-item>
            <el-breadcrumb-item :to="{ path: '/academic_Management/academic_font_management/academic_paper_management_home' }">学术出题系统</el-breadcrumb-item>
            <el-breadcrumb-item>单轮淘汰出题系统</el-breadcrumb-item>
        </el-breadcrumb>
        <el-row>
          <el-col :span="12"><el-page-header @back="goBack"></el-page-header></el-col>
          <el-col :span="12" align="right">
            <div class="view-change" @click=" view = view === 'grid' ? 'list' : 'grid'">
              <img v-if="view === 'grid'" src="../../../../assets/img/view-grid-1.png" alt="">
              <span v-if="view === 'grid'">宫格视图</span>
              <!-- <img v-if="view === 'grid'" src="../../../../assets/img/view-list-1.png" alt=""> -->
              <img v-if="view === 'list'" src="../../../../assets/img/view-list-2.png" alt="">
              <span v-if="view === 'list'">列表视图</span>
              <!-- <img v-if="view === 'list'" src="../../../../assets/img/view-grid-2.png" alt=""> -->
            </div>
          </el-col>
        </el-row>
        <!-- 筛选 -->
        <el-card style="margin-top: 15px">
            <el-row class="title_row">
                <el-col>
                    <span class="title_class">条件筛选</span>
                </el-col>
            </el-row>
            <el-form ref="queryFormRef" :model="queryForm" label-width="80px">
                <el-row :gutter="20">
                    <el-col :span="8">
                        <el-form-item label="赛季" prop="season">
                            <el-select
                                placeholder="请选择类型"
                                style="width: 100%"
                                v-model="queryForm.season"
                            >
                                <el-option
                                    v-for="item in dict_season"
                                    :key="item.dictCode"
                                    :label="item.dictLabel"
                                    :value="item.dictValue"
                                ></el-option>
                            </el-select> </el-form-item
                    ></el-col>
                    <el-col :span="8">
                        <el-form-item label="赛程" prop="raceSchedule">
                            <el-select
                                v-model="queryForm.raceSchedule"
                                placeholder="请选择"
                                style="width: 100%"
                            >
                                <el-option
                                    v-for="item in dict_matchType"
                                    :key="item.id"
                                    :label="item.scheduleName"
                                    :value="item.id"
                                ></el-option>
                            </el-select> </el-form-item
                    ></el-col>
                    <el-col :span="8">
                        <el-form-item label="赛区" prop="districtId">
                            <el-select
                                placeholder="请选择"
                                style="width: 100%"
                                v-model="queryForm.districtId"
                                clearable
                                multiple
                            >
                                <el-option
                                    v-for="item in dict_district"
                                    :key="item.id"
                                    :label="item.districtName"
                                    :value="item.id"
                                ></el-option>
                            </el-select>
                        </el-form-item>
                    </el-col>
                    <el-col :span="8">
                        <el-form-item label="组别" prop="level">
                            <el-select
                                placeholder="请选择"
                                v-model="queryForm.level"
                                style="width: 100%"
                            >
                                <el-option
                                    v-for="item in dict_Group"
                                    :key="item.dictCode"
                                    :label="item.dictLabel"
                                    :value="item.dictValue"
                                ></el-option>
                            </el-select>
                        </el-form-item>
                    </el-col>
                    <el-col :span="8">
                        <el-form-item label="名称" prop="name">
                            <el-input
                                v-model="queryForm.name"
                                placeholder="请输入"
                                clearable
                            ></el-input>
                        </el-form-item>
                    </el-col>
                    <el-col :span="8" align="right">
                        <el-button
                            type="primary"
                            @click="searchResult"
                            >查询</el-button
                        >
                        <el-button
                          type="primary"
                          plain
                          @click="reset"
                          >重置</el-button
                      >
                    </el-col>
                </el-row>
            </el-form>
        </el-card>
        <el-row class="title_row" style="margin-top: 15px" align="middle" type="flex">
            <el-col :span="5">
                <span class="title_class" style="margin-left: 20px;">试卷列表</span>
            </el-col>
            <el-col :span="19" style="text-align: right" v-if="view === 'list'">
                <el-button type="primary" @click="addExamDataClicked"
                    >创建试卷</el-button
                >
                <!-- <el-button type="primary" plain @click="secondedClicked"
                    >复议单词</el-button
                > -->
            </el-col>
        </el-row>
          <!-- 列表 -->
          <el-row :gutter="24" v-if="view === 'grid'">
            <el-col :span="6">
              <div class="paper-card2" @click="addExamDataClicked">
                <img src="../../../../assets/img/paper-add.png" alt="">
                <div>创建试卷</div>
              </div>
            </el-col>
            <el-col :span="6" v-for="(item, i) in dataList" :key="i">
              <div class="paper-card">
                <div class="block2">{{ item.season }}</div>
                <div class="block1">{{ item.raceScheduleName }}</div>
                <div class="paper-name"><i class="el-icon-edit-outline icon-btn" @click="editDistrictMessage(item)"></i> {{ item.name }}</div>
                <div class="paper-flex">
                  <div class="part1">
                    <div class="paper-tit">组别</div>
                    <div class="paper-value">{{ groupFormatter(item) }}</div>
                  </div>
                  <div class="part2">
                    <div class="paper-tit">类型</div>
                    <div class="paper-value">{{ typeFormat(item) }}</div>
                  </div>
                </div>
                <div class="area">
                  <div class="paper-tit">赛区</div>
                  <div class="tag" v-for="value in item.districts" :key="value.id">{{ value.districtName }}</div>
                  <div class="tag" v-if="!item.districts">全部赛区</div>
                </div>
                <div class="btns">
                  <!-- <div class="btn" @click="editDistrictMessage(item)"><i class="el-icon-edit-outline"></i> 编辑</div> -->
                  <div class="btn" @click="turnDetailData(item)"><i class="el-icon-document"></i> 查看单词</div>
                  <div class="btn" @click="setSortFn(item.id)"><i class="el-icon-sort"></i> 单词乱序</div>
                </div>
              </div>
            </el-col>
          </el-row>
          <el-table v-if="view === 'list'"
              header-cell-class-name="tableHeaderStyle"
              :data="dataList"
              border
              stripe
          >
              <el-table-column label="序号" type="index"></el-table-column>
              <el-table-column label="赛季" prop="season"> </el-table-column>
              <el-table-column label="试卷名称" prop="name"></el-table-column>
              <el-table-column label="试卷类型" prop="type" :formatter="typeFormat"></el-table-column>
              <el-table-column
                  label="赛程"
                  prop="raceScheduleName"
              ></el-table-column>
              <el-table-column label="赛区">
                <template slot-scope="scope">
                  <div v-for="value in scope.row.districts" :key="value.id">{{ value.districtName }}</div>
                  <div v-if="!scope.row.districts">全部赛区</div>
                </template>
              </el-table-column>
              <el-table-column
                  label="组别"
                  prop="level"
                  :formatter="groupFormatter"
              ></el-table-column>
              <el-table-column label="操作" width="250px">
                  <template slot-scope="scope">
                      <el-button
                          type="text"
                          icon="el-icon-edit"
                          size="mini"
                          @click="editDistrictMessage(scope.row)"
                          >编辑试卷</el-button
                      >
                      <el-button
                          type="text"
                          icon="el-icon-document"
                          size="mini"
                          @click="turnDetailData(scope.row)"
                          >单词列表</el-button
                      >
                      <el-button
                          type="text"
                          icon="el-icon-sort"
                          size="mini"
                          @click="setSortFn(scope.row.id)"
                          >单词乱序</el-button
                      >
                  </template>
              </el-table-column>
          </el-table>
          <div style="text-align: center;">
              <!-- 分页 -->
            <el-pagination
                @size-change="handleSizeChange"
                @current-change="handleCurrentChange"
                :current-page="queryForm.pageNum"
                :page-sizes="[11, 22, 33, 44]"
                :page-size="queryForm.pageSize"
                layout="total, sizes, prev, pager, next, jumper"
                :total="total"
            >
            </el-pagination>
          </div>
        <el-dialog
            title="试卷信息"
            :visible.sync="editPaperDialogVisible"
            width="500px"
            @close="editPaperDialogVisibleClose"
        >
            <el-form
                :model="editQueryForm"
                label-width="100px"
                ref="editPaperInfoFormRef"
                :rules="editPaperInfoFormRules"
                style="width: 100%"
            >
                <el-form-item label="赛季" prop="season">
                    <el-select
                        placeholder="请选择赛季"
                        style="width: 100%"
                        v-model="editQueryForm.season"
                    >
                        <el-option
                            v-for="item in dict_season"
                            :key="item.dictCode"
                            :label="item.dictLabel"
                            :value="item.dictValue"
                        ></el-option>
                    </el-select>
                </el-form-item>
                <el-form-item label="赛程" prop="raceSchedule">
                    <el-select
                        v-model="editQueryForm.raceSchedule"
                        placeholder="请选择赛程"
                        style="width: 100%"
                        ><el-option
                            v-for="item in dict_matchType"
                            :key="item.id"
                            :label="item.scheduleName"
                            :value="item.id"
                        >
                        </el-option>
                    </el-select>
                </el-form-item>
                <!-- 赛区 -->
                <el-form-item label="赛区" prop="districtId" v-if="editQueryForm.raceSchedule === '5'">
                  <el-select
                      placeholder="请选择"
                      style="width: 100%"
                      v-model="editQueryForm.districtId"
                      clearable
                      multiple
                  >
                      <el-option
                          v-for="item in dict_district"
                          :key="item.id"
                          :label="item.districtName"
                          :value="item.id"
                      ></el-option>
                  </el-select>
                  <div class="tip">未设置赛区,该赛程所有赛区比赛都可使用</div>
                </el-form-item>
                <el-form-item label="试卷组别" prop="level" v-if="editQueryForm.raceSchedule !== '8'">
                    <el-select v-model="editQueryForm.level" style="width: 100%">
                        <el-option
                            v-for="item in dict_Group"
                            :key="item.dictCode"
                            :label="item.dictLabel"
                            :value="item.dictValue"
                        ></el-option>
                    </el-select>
                </el-form-item>
                <el-form-item label="试卷类型" prop="type">
                    <el-select v-model="editQueryForm.type" style="width: 100%">
                        <el-option
                            v-for="item in questionPaper_type"
                            :key="item.dictCode"
                            :label="item.dictLabel"
                            :value="item.dictValue"
                        ></el-option>
                    </el-select>
                </el-form-item>
                <el-form-item label="试卷名称" prop="name">
                        <el-input
                            placeholder="请输入"
                            v-model="editQueryForm.name"
                        ></el-input>
                </el-form-item>
            </el-form>
            <span slot="footer" class="dialog-footer">
                <el-button @click="editPaperDialogVisible = false"
                    >取 消</el-button
                >
                <el-button type="primary" @click="addQuestionPaperDataClicked"
                    >确 定</el-button
                >
            </span>
        </el-dialog>
    </div>
</template>

<script>
import { getCityQuestionPaper, deleteCityQuestionWord, cityQuestionPaper, editCityQuestionPaper, queryDistrictPage } from '@/http/api'
export default {
  components: {
  },
  data () {
    return {
      view: 'grid',
      isEdit: false,
      dataList: [],
      raceScheduleList: this.$chnEngPublicRequest.querySeasonRaceSchedule(this, { activityType: '1' }).then(value => { this.raceScheduleList = value }),
      dict_matchType: this.$chnEngPublicRequest.querySeasonRaceSchedule(this, { activityType: '1' }).then(value => {
        this.dict_matchType = value.filter(item => item.id !== '1' && item.id !== '2' && item.id !== '4' && item.id !== '6')
      }),
      dict_district: [],
      dict_season: this.$userInfo.getDataList(this, 't_season', this.$store.state.flag).then(value => { this.dict_season = value }),
      dict_Group: this.$userInfo.dict_group(),
      questionPaper_type: this.$userInfo.questionPaper_type(),
      total: 0,
      editPaperDialogVisible: false,
      editPaperInfoFormRules: {
        season: [{ required: true, message: '请选择', trigger: 'change' }],
        raceSchedule: [{ required: true, message: '请选择', trigger: 'change' }],
        difficulty: [{ required: true, message: '请选择', trigger: 'change' }],
        level: [{ required: true, message: '请选择', trigger: 'change' }],
        type: [{ required: true, message: '请选择', trigger: 'change' }],
        name: [{ required: true, message: '请输入', trigger: 'blur' }]
      },
      editQueryForm: {
        season: this.$chnEngStatusCode.defaultSeason,
        raceSchedule: '5',
        activityType: this.$chnEngStatusCode.activityType,
        difficulty: null,
        level: null,
        name: '',
        type: null,
        districtId: ''
      },
      queryForm: {
        season: this.$chnEngStatusCode.defaultSeason,
        raceSchedule: '',
        name: '',
        level: null,
        districtId: '',
        pageNum: 1,
        pageSize: 11
      }
    }
  },
  created () {
    this.getDistrictList()
    this.searchResult()
    // setTimeout(() => {
    //   console.log(this.dict_matchType)
    // }, 1000)
  },
  methods: {
    goBack () {
      this.$router.back()
    },
    // 获取赛区筛选数据
    getDistrictList () {
      queryDistrictPage({ pageNum: 1, pageSize: 10000 }).then((res) => {
        this.dict_district = res.data.list
      }).catch((err) => {
        console.log('err', err)
      })
    },
    searchResult () {
      getCityQuestionPaper(this.queryForm).then((res) => {
        this.dataList = res.data.list
        this.total = res.data.total
      }).catch((err) => {
        console.log('返回的err', err)
      })
    },
    reset () {
      this.$refs.queryFormRef.resetFields()
      this.queryForm.pageNum = 1
      this.queryForm.pageSize = 10
      this.searchResult()
    },
    handleSizeChange (newSize) {
      this.queryForm.pageSize = newSize
      this.searchResult()
    },
    handleCurrentChange (newCurPage) {
      this.queryForm.pageNum = newCurPage
      this.searchResult()
    },
    // 添加试卷点击
    addExamDataClicked () {
      this.isEdit = false
      this.editPaperDialogVisible = true
    },
    // 编辑点击事件
    editDistrictMessage (rowData) {
      this.isEdit = true
      this.editPaperDialogVisible = true
      this.$nextTick(() => { // 注意看这里
        this.editQueryForm = { ...rowData }
        if (rowData.districts) {
          this.editQueryForm.districtId = rowData.districts.map(item => item.id)
        }
        this.editQueryForm.raceSchedule = this.editQueryForm.raceSchedule + ''
      })
    },
    addQuestionPaperDataClicked () {
      this.$refs.editPaperInfoFormRef.validate(valid => {
        if (!valid) return
        console.log(this.editQueryForm)
        if (this.editQueryForm.districtId && this.editQueryForm.districtId.length) {
          this.editQueryForm.districtId = this.editQueryForm.districtId.join(',')
        } else {
          this.editQueryForm.districtId = ''
        }
        if (this.isEdit === true) {
          editCityQuestionPaper(this.editQueryForm).then((res) => {
            this.editPaperDialogVisible = false
            this.searchResult()
          }).catch((err) => {
            console.log('返回的err', err)
          })
        } else {
          cityQuestionPaper(this.editQueryForm).then((res) => {
            this.editPaperDialogVisible = false
            this.searchResult()
          }).catch((err) => {
            console.log('返回的err', err)
          })
        }
      })
    },
    // 添加试卷关闭
    editPaperDialogVisibleClose () {
      this.$refs.editPaperInfoFormRef.resetFields()
    },
    // 删除
    deleteDialog (rowId) {
      this.$confirm('是否确认删除该试卷?', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(async () => {
        deleteCityQuestionWord({ id: rowId }).then((res) => {
          this.searchResult()
        }).catch((err) => {
          console.log('返回的err', err)
        })
      })
    },
    // 跳转详情
    turnDetailData (rowData) {
      this.$router.push({
        path: '/academic_Management/academic_font_management/academic_examination_fengtalk',
        query: {
          paperId: rowData.id,
          level: rowData.level,
          paperName: rowData.name
        }
      })
    },
    secondedClicked () {
      this.$router.push({
        path: '/academic_Management/academic_font_management/academic_examination_second'
      }
      )
    },
    closeFn () {
      this.editCharactersDialogVisible = false
    },
    groupFormatter (data) {
      var temp = '未设置'
      for (const key in this.dict_Group) {
        if (Object.hasOwnProperty.call(this.dict_Group, key)) {
          const element = this.dict_Group[key]
          if (element.dictValue === data.level) {
            temp = element.dictLabel
          }
        }
      }
      return temp
    },
    typeFormat (data) {
      return data.type ? this.questionPaper_type.find(item => item.dictValue === data.type).dictLabel : ''
    },
    // 一键乱序
    setSortFn (id) {
      this.$confirm('单词顺序将随机打乱，确认操作?', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(async () => {
        this.$http.post('cityQuestionWord/oneClickDisorder', { id }).then(res => {
          if (res.code === 200) {
            this.$message.success('操作成功')
          }
        })
      })
    }
  }
}
</script>

<style lang="less" scoped>
.tip{
  font-size: 12px;
  color: #a6a6a6;
}
.paper-card2{
  cursor: pointer;
  height: 240px;
  width: 100%;
  background-color: #fff;
  box-shadow: rgba(0, 0, 0, 0.05) 0px 2px 12px 0px;
  border-radius: 10px;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  img{
    width: 80px;
    height: 80px;
    margin-bottom: 10px;
  }
  font-size: 16px;
  color: #79BBFF;
}
.paper-card{
  position: relative;
  height: 240px;
  width: 100%;
  padding-top: 54px;
  padding-left: 10px;
  padding-right: 10px;
  box-sizing: border-box;
  background-color: #fff;
  box-shadow: rgba(0, 0, 0, 0.05) 0px 2px 12px 0px;
  border-radius: 10px 0 10px 10px;
  margin-bottom: 20px;
  background-image: url(../../../../assets/img/paper.png);
  background-position: right bottom;
  background-size: 80px 80px;
  background-repeat: no-repeat;
  .block1{
    background: linear-gradient(75deg, #4096ff, #66B1FF);
    // width: 162px;
    height: 30px;
    border-radius: 0 30px 30px 0;
    position: absolute;
    left: -6px;
    top: 16px;
    box-shadow: rgba(64, 150, 255, .3) 0px 4px 8px 0px;
    color: #fff;
    font-size: 15px;
    font-weight: bold;
    line-height: 30px;
    padding-left: 14px;
    padding-right: 20px;
  }
  .block2{
    font-size: 12px;
    color: #000;
    background: linear-gradient(to right, #fff, #ECF5FF, #C6E2FF);
    position: absolute;
    right: 0;
    top: 20px;
    height: 20px;
    line-height: 20px;
    width: 60px;
    padding-right: 12px;
    text-align: right;
  }
  .paper-flex{
    display: flex;
    align-items: flex-start;
    justify-content: space-between;
    .part1{
      width: 70%;
    }
    .part2{
      width: 30%;
    }
  }
  .paper-tit{
    font-size: 10px;
    color: #909399;
  }
  .paper-value{
    font-size: 12px;
    font-weight: bold;
    color: #000;
    margin-bottom: 10px;
  }
  .paper-name{
    font-size: 16px;
    font-weight: bold;
    color: #000;
    margin-bottom: 14px;
    width: 100%;
    overflow: hidden;
    text-overflow: ellipsis;
    white-space: nowrap;
  }
}
.tag{
  font-size: 10px;
  background-color: #ECF5FF;
  color: #000;
  padding: 2px 4px;
  margin-right: 6px;
  margin-bottom: 2px;
  display: inline-block;
}
.area{
  height: 64px;
  overflow: hidden;
}
.btns{
  display: flex;
  width: 80%;
  margin-top: 10px;
  .btn{
    border-radius: 20px;
    border: 1px solid #b3d8ff;
    text-align: center;
    font-size: 12px;
    color: #4096ff;
    cursor: pointer;
    padding: 2px 6px;
    margin-right: 10px;
    &:hover{
      background-color: #ecf5ff;
    }
  }
}
.icon-btn{
  color: #4096ff;
  cursor: pointer;
}
.title_row_card{
  background-color: #fff;
  margin-top: 15px;
  padding: 20px;
  box-shadow: 0 2px 12px 0 rgba(0,0,0,.1);
  border-radius: 4px;
}
.view-change{
  cursor: pointer;
  width: 66px;
  background-color: #ECF5FF;
  border-radius: 6px;
  padding: 6px 10px;
  box-shadow: inset 0 0 10px rgba(64, 150, 255, .5);
  display: flex;
  align-items: center;
  justify-content: space-between;
  font-size: 12px;
  color: #909399;
  img{
    width: 14px;
  }
}
</style>
